import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { CmsProvider } from './contexts/CmsContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <CmsProvider>
        <App />
      </CmsProvider>
    </AuthProvider>
  </React.StrictMode>
);
